import store, { RootState } from "@/redux/store";
import { PaymentMethodPlugin } from "@/types";
import { ExtensionApi } from "@/services/extensionApi";
import { IPlugin, PluginStore } from "react-pluggable";

class PaymentMethodsPlugin implements IPlugin {
  namespace = "PaymentMethods";
  pluginStore: PluginStore;

  async getPlugins(): Promise<PaymentMethodPlugin[]> {
    const state = store.getState() as RootState;
    const orgId = state.auth.userInfo?.user?.org_id;
    if (!orgId) return [];
    const promise = store.dispatch(
      ExtensionApi.endpoints.getAllExtensions.initiate({ org_id: orgId, query: "type=payment&for_admin=true" })
    );
    const { data: extensions } = await promise;
    return extensions?.data || [];
  }

  getPluginName(): string {
    return `${this.namespace}@1.0.0`;
  }

  getDependencies(): string[] {
    return [];
  }

  init(pluginStore: PluginStore) {
    this.pluginStore = pluginStore;
  }

  activate() {
    this.pluginStore.addFunction(
      `${this.namespace}.getPlugins`,
      this.getPlugins.bind(this)
    );
  }

  deactivate() {
    this.pluginStore.removeFunction(`${this.namespace}.getPlugins`);
  }
}

export default PaymentMethodsPlugin;
